module.exports = __webpack_public_path__ + "static/media/close-icon-white.9250dad7.svg";